module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "popup-overlay",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "popup-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "popup-header"
  }, [_c('span', {
    staticClass: "popup-title"
  }, [_vm._v("警告")]), _vm._v(" "), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-body"
  }, [_c('p', [_vm._v("資訊之芽的 Online Judge 已經搬移到"), _c('a', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold"
    },
    attrs: {
      "href": "https://tioj.sprout.tw"
    }
  }, [_vm._v("新版網站")])]), _vm._v(" "), _c('p', [_vm._v("本網站之服務已經終止")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f4ee945"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarningMessage.vue
// module id = 572
// module chunks = 0